import React, { Component } from 'react';
import AboutComponent from '../../_Componants/About/About';

class About extends Component{
    render(){
        return (
            <div>
                <AboutComponent/>
            </div>
        )
    }
}

export default About;